import React from 'react';
import {
  PRE_VISIT_PROMPT_CLICK_PHOTO_ID,
  PRE_VISIT_PROMPT_SHOW_PHOTO_ID_SCREEN,
} from '../../../../../core/analytics/events';
import { Steps } from './PromptHeader/util';
import Prompt from './Prompt';
import { emptyFunction } from '../../../../../core/util/function';
import history from '../../../../../core/history';
import { PHOTO_ID_UPLOAD } from '../../../../../core/util/bookingFlowRouting';
import { safeGet } from '../../../../../core/util/object';

type Props = {
  handleSkip: (...args: any[]) => any;
  handleGoBack: (...args: any[]) => any;
  fetchPublicBooking: (...args: any[]) => any;
  fetchBooking: (...args: any[]) => any;
  fetchLocation: (...args: any[]) => any;
  location: any;
  booking: any;
  accountSummary: any;
  bookingError?: string;
  bookingId: string;
  isLoggedIn: boolean;
  progressBarSteps?: any[];
  setProgressBarSteps: (...args: any[]) => any;
};

const PhotoIdUploadPrompt = (props: Props) => {
  const {
    handleSkip,
    handleGoBack,
    fetchPublicBooking,
    fetchBooking,
    booking,
    accountSummary,
    location,
    bookingError,
    bookingId,
    isLoggedIn,
    progressBarSteps,
    setProgressBarSteps,
  } = props;

  const handleUploadPhotoIdClick = () => history.push(`${PHOTO_ID_UPLOAD}/vv`);

  return (
    <Prompt
      accountSummary={accountSummary}
      activeStep={Steps.PHOTO_ID}
      booking={booking}
      bookingError={bookingError}
      bookingId={bookingId}
      fetchBooking={fetchBooking}
      fetchLocation={emptyFunction}
      fetchPublicBooking={fetchPublicBooking}
      handleGoBack={handleGoBack}
      handleMainCtaClick={handleUploadPhotoIdClick}
      handleSkip={handleSkip}
      icon="/images/upload_id.png"
      iconAltText="Upload ID"
      isLoggedIn={isLoggedIn}
      isRequiredStep={false}
      loadingTrackingEvent={PRE_VISIT_PROMPT_SHOW_PHOTO_ID_SCREEN}
      location={location}
      mainCtaButtonCopy="Upload ID"
      mainCtaTrackingEvent={PRE_VISIT_PROMPT_CLICK_PHOTO_ID}
      progressBarSteps={progressBarSteps}
      setProgressBarSteps={setProgressBarSteps}
      subText={
        safeGet(location)('customPhotoIdUploadCopy') ||
        "Please upload a driver's license or other government issued ID so the doctor can verify they're seeing the right person."
      }
      title="Upload ID"
    />
  );
};

export default PhotoIdUploadPrompt;
